import Calculator from '../components/Calculator/Calculator';

const CalculatorPage = () => {
  return (
    <>
      <Calculator />
    </>
  );
};
export default CalculatorPage;
